import { useEffect } from 'react';

/**
 * Ctrl+A (⌘A) outside a text box selects the messages. The rest of the app
 * cannot be selected, so the browser's own select-all would take nothing.
 */
export function useSelectAll(messages: HTMLElement | null) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (!(e.ctrlKey || e.metaKey) || e.altKey || e.shiftKey || e.key.toLowerCase() !== 'a') return;
      const target = e.target instanceof HTMLElement ? e.target : null;
      if (target && (target.isContentEditable || target.closest('input, textarea'))) return;
      const selection = window.getSelection();
      if (!messages || !selection) return;
      e.preventDefault();
      const range = document.createRange();
      range.selectNodeContents(messages);
      selection.removeAllRanges();
      selection.addRange(range);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [messages]);
}
